import { CORVA_API_URLS } from './constants';

/**
 * @param {string=} path
 * @returns {string}
 */
export function getApiUrl(path = '') {
  return new URL(path, CORVA_API_URLS.API).href;
}

/**
 * @param {string=} path
 * @returns {string}
 */
export function getDataApiUrl(path = '') {
  return new URL(path, CORVA_API_URLS.DATA_API).href;
}

/**
 * @param {string=} path
 * @returns {string}
 */
export function getFusionApiUrl(path = '') {
  return new URL(path, CORVA_API_URLS.FUSION_API).href;
}

/**
 * @param {string=} path
 * @returns {string}
 */
export function getStreamXApiUrl(path = '') {
  return new URL(path, CORVA_API_URLS.STREAMX_API).href;
}
